import { Injectable, Optional, Inject, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Event, PageData } from '../models';
import { BASE_URL } from '@teamfoster/sdk/ssr';

@Injectable({
  providedIn: 'root',
})
export class EventsService {
  #http = inject(HttpClient);
  #BASE_URL = inject(BASE_URL, { optional: true });

  getEvents(profileId: number, skip: number = 0, take: number = 0) {
    return this.#http.get<{ items: Event[]; page: PageData }>(
      `${this.#BASE_URL}api/disease-profiles/${profileId}/Events?take=${take}&skip=${skip}`
    );
  }

  getEventDetail(id: number) {
    return this.#http.get<Event>(`${this.#BASE_URL}api/events/${id}`);
  }
}
